import { forwardRef } from 'preact/compat';
import { useProperties, useFormProps, SvgIcon } from '@/features/form';
import HandleTabIndex from './HandleTabIndex';

export default forwardRef(function Selectable({ children, block, ...props }, ref) {
	const { conversational } = useProperties();
	const { multipleIndex, isMultiple } = useFormProps();
	const type =
		['radio', 'checkbox'].indexOf(block.typeName) > -1 ? block.typeName : 'radio';
	const wrapperClass =
		['radio', 'checkbox', 'gcr', 'thumbs', 'category'].indexOf(block.typeName) > -1
			? `${block.typeName}-wrapper ${
					conversational ||
					['gcr', 'thumbs', 'category'].indexOf(block.typeName) > -1 ||
					block.properties.show_as_buttons
						? 'button'
						: ''
			  } ${props.dummyScore ? 'dummy-score' : ''}`
			: `${block.typeName}-choice ${props.dummyScore ? 'dummy-score' : ''}`;

	let attr = {
		// onChange: (event) => {
		// 	//wcag uses -1 as dummyvalue for unselected scores
		// 	// if (event.target.value != -1) {
		// 	// 	props.updateForm(block.typeName !== 'checkbox' ? event.target.value : event.target.checked ? true : '', block, props.elementIndex)
		// 	// }else {
		// 	// 	props.updateForm('', block, props.elementIndex);
		// 	// }
		// 	props.updateForm(block.typeName !== 'checkbox' ? event.target.value : event.target.checked ? true : '', block, props.elementIndex);
		// },
		...props,
		type: type,
		name: `${block.typeName}-group-${block.id}${isMultiple ? '_' + multipleIndex : ''}`,
		value: props.value,
		id: `${block.typeName}-${block.id}_${props.selectableIndex}${
			isMultiple ? '_' + multipleIndex : ''
		}`,
		checked: props.checked
	};

	if (props.ariaLabel) {
		attr['aria-label'] = props.ariaLabel;
	}

	if (props.onKeyUp) {
		attr.onKeyUp = props.onKeyUp;
	}

	return (
		<div class={wrapperClass}>
			<HandleTabIndex
				component="input"
				data-testid="selectable"
				{...attr}
			/>
			<label
				ref={ref}
				for={attr.id}
				{...props.labelAtts}
			>
				{block.typeName === 'checkbox' && !block.properties.show_as_buttons && (
					<SvgIcon
						icon="check"
						className="is-context-icon"
					/>
				)}
				{children}
			</label>
		</div>
	);
});
